export const paiementsData = [
  {
    id: 1,
    nomEtablissement: "Lycée Jean Moulin",
    formule: "Formule Premium",
    montant: 1170,
    datePaiement: "2025-01-15",
    dateExpiration: "2026-01-15",
    statut: "Payé"
  },
  {
    id: 2,
    nomEtablissement: "Collège Victor Hugo",
    formule: "Formule Basique",
    montant: 900,
    datePaiement: "2024-01-10",
    dateExpiration: "2025-01-10",
    statut: "Payé"
  },
  {
    id: 3,
    nomEtablissement: "École Élémentaire Pasteur",
    formule: "Formule IA",
    montant: 1250,
    datePaiement: null,
    dateExpiration: null,
    statut: "Impayé"
  },
  {
    id: 4,
    nomEtablissement: "Lycée Sainte-Anne",
    formule: "Formule IA",
    montant: 1625,
    datePaiement: "2025-07-01",
    dateExpiration: "2026-07-01",
    statut: "Payé"
  }
];
